import { ReactNode } from 'react';
import cx from 'classnames';
import { Text } from '@intellecteu/common-ui';
import { useRoles } from 'app/utils';

import s from './styles.module.scss';

interface IPageCaption {
  caption?: string;
  content?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export const PageCaption = ({ caption, content, action, className }: IPageCaption) => {
  const { isAdmin } = useRoles();

  return (
    <div className={cx(s.captionWrapper, className)}>
      <div className={s.captionWrapperContent}>
        <Text size={Text.size.xxl} weight={Text.weight.bold}>
          {caption}
        </Text>
        {content}
      </div>
      {isAdmin && <div className={s.captionWrapperActions}>{action}</div>}
    </div>
  );
};
